import React, { useState, useEffect } from 'react';
import { useTheme } from '../ThemeContext';
import styles from './Calendar.module.css';



  

const Calendar = () => {
  const { theme } = useTheme();
  
  
  return (
  <>
      <aside className={`${styles.calendar} ${styles[theme]}`}>
            <div className={`${styles.textHeading} ${styles[theme]}`}>Calendar</div>
            
      </aside>
      
  </>
  )
}

export default Calendar